module["exports"] = [
  "Västra",
  "Östra",
  "Norra",
  "Södra",
  "Övre",
  "Undre"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sv/address/street_prefix.js
// module id = 3578
// module chunks = 1609